import "ngstorage";

class PostorderController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    TeamsService,
    CompaniesService,
    SecurityService,
    $filter,
    EventsService,
    $timeout,
    $location,
    $rootScope,
    $scope,
    TrackingService
  ) {
    this.name = "postorder";
    $localStorage.activeStateName = "postorder";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$scope = $scope;
    this.$env = EnvService;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.currentUser = this.$auth.getUserData();
    this.tracking = TrackingService;
    this.$teams = TeamsService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$filter = $filter;
    this.$stateParams = $stateParams;
    this.$events = EventsService;
    this.$timeout = $timeout;
    this.page = 1;
    this.minutes_to_add_to_start_of_day = null;
    this.remain_loading_count = 1;
    this.page_loading = true;
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
    this.tracker = {
      currentStep: 0,
      previousStep: null,
      nextStep: null,
      visited_steps: [0],
    };
    this.statusBarStatus = {
      step_2: {
        visited: false,
        bar_class: "app-progress-bar",
        dot_class: "select",
      },
      step_3: {
        visited: false,
        bar_class: "app-progress-bar",
        dot_class: "select",
      },
      step_4: {
        visited: false,
        bar_class: "app-progress-bar",
        dot_class: "select",
      },
      step_5: {
        visited: false,
        bar_class: "app-progress-bar",
        dot_class: "select",
      },
    };

    this.order_creation_ui = {
      first_page: {
        is_error: false,
        is_error_location: false,
        is_error_location_msg: null,
        is_error_address: false,
        is_error_address_msg: null,
        is_error_date: false,
        is_error_date_msg: null,
        is_error_time: false,
        is_error_time_msg: null,
        is_error_instructions: false,
        is_error_instructions_msg: null,
      },
      second_page: {
        is_error: false,
        is_error_location: false,
        is_error_location_msg: null,
        is_error_address: false,
        is_error_address_msg: null,
        is_error_date: false,
        is_error_date_msg: null,
        is_error_time: false,
        is_error_time_msg: null,
        is_error_instructions: false,
        is_error_instructions_msg: null,
      },
      third_page: {
        is_error: false,
        is_error_order_name: false,
        is_error_order_name_msg: null,
      },
      fourth_page: {
        is_error: false,
      },
    };

    this.order = {
      name: null,
      openings: 1,
      hourly_rate: 0,
      dress_code: null,
      payment: null,
      description: null,
      number: null,
      jobble_type_id_for_backend: null,
      user_time_zone: null,
      teams_for_order: [],
      pickup: {
        address: null,
        time_zone: null,
        raw_offset: null,
        date: null,
        date_formatted: null,
        location: null,
        instructions: null,
        contactInfo: null,
        time: null,
        contact: null,
      },
      dropoff: {
        address: null,
        time_zone: null,
        raw_offset: null,
        date: null,
        date_formatted: null,
        location: null,
        instructions: null,
        contactInfo: null,
        time: null,
        contact: null,
      },
    };

    this.check_params();
    this.load_page();
    this.set_date_picker();
    this.set_times();
    this.set_padding();
    this.check_teams();
    this.check_for_clone();
    this.check_root();

    var _this = this;

    _this.SetAddressListener = _this.$rootScope.$on("SetAddress", function ($event, params) {
      _this.set_address(params);
    });
    _this.SetJobbleTypesListener = _this.$rootScope.$on("SetJobbleTypes", function ($event, params) {
      _this.check_root(params);
    });

    _this.$scope.$on("$destroy", _this.SetAddressListener);
    _this.$scope.$on("$destroy", _this.SetJobbleTypesListener);
  }

  validate_first_page() {
    var _this = this;
    _this.setLoader();
    _this.remain_loading_count = 1;
    let validation_array = _this.validate_fields_on_first_page();
    if (validation_array === true) {
      _this.remain_loading_count = 0;
      _this.unSetLoader();
    } else if (_this.order_creation_ui.first_page.is_error) {
      _this.set_errors_to_page(validation_array);
      _this.remain_loading_count = 0;
      _this.unSetLoader();
    } else {
      _this.times.value.id = 1;
      _this.setNextDay();
      _this.page = 2;
      _this.statusBarStatus.step_2.visited = true;
      _this.tracker.visited_steps.push(2);
      _this.some_date_moment = null;
      _this.minutes_to_add_to_start_of_day = null;
      if (_this.cloned_event) {
        _this.set_second_page_to_clone(_this.cloned_event);
      }
      _this.$timeout(function () {
        _this.unSetLoader();
        _this.remain_loading_count = 0;
      }, 1000);
    }
  }

  validate_second_page() {
    var _this = this;
    let validation_array = _this.validate_fields_on_second_page();
    if (validation_array === true) {
      _this.remain_loading_count = 0;
      _this.unSetLoader();
    } else if (_this.order_creation_ui.second_page.is_error) {
      _this.set_errors_to_second_page(validation_array);
      _this.remain_loading_count = 0;
      _this.unSetLoader();
    } else {
      _this.page = 3;
      _this.statusBarStatus.step_3.visited = true;
      _this.tracker.visited_steps.push(3);
      if (_this.cloned_event) {
        _this.set_third_page_to_clone();
      }
    }
  }

  validate_third_page() {
    var _this = this;
    let validation_array = _this.validate_fields_on_third_page();
    if (_this.order_creation_ui.third_page.is_error) {
      _this.set_errors_to_third_page(validation_array);
      _this.remain_loading_count = 0;
      _this.unSetLoader();
    } else {
      _this.set_dates_for_display();
      _this.page = 4;
      _this.statusBarStatus.step_4.visited = true;
      _this.setPayment();
      _this.tracker.visited_steps.push(4);
    }
  }

  set_dates_for_display() {
    var _this = this;
    let pud = _this.order.pickup.date_time;
    let dod = _this.order.dropoff.date_time;

    console.log("whats the pick up date");
    console.dir(pud);

    if (!pud) {
      if (_this.order.pickup.date_moment) {
        _this.order.pickup.date_time = _this.order.pickup.date_moment.format();
      } else if (_this.order.pickup.date) {
        _this.order.pickup.date_time = _this.order.pickup.date.format();
      }
    }
    if (!dod) {
      if (_this.order.dropoff.date_moment) {
        _this.order.dropoff.date_time = _this.order.dropoff.date_moment.format();
      } else if (_this.order.dropoff.date) {
        _this.order.dropoff.date_time.format();
      }
    }
  }

  setPayment() {
    var _this = this;
    _this.order.payment_display = _this.order.payment_formatted / 100;
  }

  validate_fourth_page() {
    var _this = this;
    _this.$timeout(function () {
      $("#modal-post-event").modal();
    });
  }

  validate_fields_on_third_page() {
    var _this = this;
    let third_page_errors = [];
    let order_name_check = null;
    let order_payment_check = null;
    order_name_check = _this.validate_order_name();
    if (order_name_check.error) {
      third_page_errors.push(order_name_check);
    }
    order_payment_check = _this.validate_order_payment();
    if (order_payment_check.error) {
      third_page_errors.push(order_payment_check);
    }
    if (third_page_errors.length > 0) {
      _this.order_creation_ui.third_page.is_error = true;
    } else {
      _this.order_creation_ui.third_page.is_error = false;
    }
    _this.format_payment();
    return third_page_errors;
  }

  format_payment() {
    var _this = this;
    let payment_parsed = null;
    let p = _this.order.payment;
    if (p) {
      if (p.includes(".")) {
        payment_parsed = parseFloat(p) * 100;
        _this.order.payment_formatted = payment_parsed;
      } else {
        payment_parsed = parseInt(p, 10) * 100;
        _this.order.payment_formatted = payment_parsed;
      }
    }
  }

  validate_fields_on_second_page() {
    var _this = this;

    if (_this.order_creation_ui.second_page.is_error) {
      return true;
    }
    let second_page_errors = [];
    let pickup_address_check = null;
    let pickup_location_check = null;
    let pickup_date = null;
    let pickup_time = null;
    let pickup_instructions = null;
    pickup_address_check = _this.validate_pickup_address();
    if (pickup_address_check.error) {
      second_page_errors.push(pickup_address_check);
    }
    pickup_location_check = _this.validate_pickup_location();
    if (pickup_location_check.error) {
      second_page_errors.push(pickup_location_check);
    }
    pickup_date = _this.validate_pickup_date();
    if (pickup_date.error) {
      second_page_errors.push(pickup_date);
    }
    pickup_time = _this.validate_pickup_time();
    if (pickup_time.error) {
      second_page_errors.push(pickup_time);
    }
    if (second_page_errors.length > 0) {
      _this.order_creation_ui.second_page.is_error = true;
    } else {
      _this.order_creation_ui.second_page.is_error = false;
    }
    return second_page_errors;
  }

  set_errors_to_third_page(errors_array) {
    var _this = this;
    errors_array.forEach(function (error_array) {
      let id = error_array.id;
      switch (id) {
        case 1:
          _this.order_creation_ui.third_page.is_error_order_name = true;
          _this.order_creation_ui.third_page.is_error_order_name_msg = error_array.message;
          break;
        case 2:
          _this.order_creation_ui.third_page.is_error_payment = true;
          _this.order_creation_ui.third_page.is_error_payment_msg = error_array.message;
          break;
      }
    });
  }

  set_errors_to_second_page(errors_array) {
    var _this = this;
    errors_array.forEach(function (error_array) {
      let id = error_array.id;
      switch (id) {
        case 1:
          _this.set_address_error_to_google_places(2);
          break;
        case 2:
          _this.order_creation_ui.second_page.is_error_location = true;
          _this.order_creation_ui.second_page.is_error_location_msg = error_array.message;
          break;
        case 3:
          _this.order_creation_ui.second_page.is_error_date = true;
          _this.order_creation_ui.second_page.is_error_date_msg = error_array.message;
          break;
        case 4:
          _this.order_creation_ui.second_page.is_error_time = true;
          _this.order_creation_ui.second_page.is_error_time_msg = error_array.message;
          break;
        case 5:
          _this.order_creation_ui.second_page.is_error_instructions = true;
          _this.order_creation_ui.second_page.is_error_instructions_msg = error_array.message;
          break;
      }
    });
  }

  set_errors_to_page(errors_array) {
    var _this = this;
    errors_array.forEach(function (error_array) {
      let id = error_array.id;
      switch (id) {
        case 1:
          _this.set_address_error_to_google_places(1);
          break;
        case 2:
          _this.order_creation_ui.first_page.is_error_location = true;
          _this.order_creation_ui.first_page.is_error_location_msg = error_array.message;
          break;
        case 3:
          _this.order_creation_ui.first_page.is_error_date = true;
          _this.order_creation_ui.first_page.is_error_date_msg = error_array.message;
          break;
        case 4:
          _this.order_creation_ui.first_page.is_error_time = true;
          _this.order_creation_ui.first_page.is_error_time_msg = error_array.message;
          break;
        case 5:
          _this.order_creation_ui.first_page.is_error_instructions = true;
          _this.order_creation_ui.first_page.is_error_instructions_msg = error_array.message;
          break;
      }
    });
  }

  set_address_error_to_google_places(page) {
    var _this = this;
    if (_this.page === 1) {
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetAddressError", {
          page: page,
        });
      });
    } else if (_this.page === 2) {
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetAddressErrorPickup", {
          page: page,
        });
      });
    }
  }

  validate_fields_on_first_page() {
    var _this = this;

    if (_this.order_creation_ui.first_page.is_error) {
      return true;
    }

    let first_page_errors = [];
    let drop_off_address_check = null;
    let drop_off_location_check = null;
    let drop_off_date = null;
    let drop_off_time = null;
    let drop_off_instructions = null;

    drop_off_address_check = _this.validate_dropoff_address();
    if (drop_off_address_check.error) {
      first_page_errors.push(drop_off_address_check);
    }

    drop_off_location_check = _this.validate_dropoff_location();
    if (drop_off_location_check.error) {
      first_page_errors.push(drop_off_location_check);
    }

    drop_off_date = _this.validate_drop_off_date();
    if (drop_off_date.error) {
      first_page_errors.push(drop_off_date);
    }

    drop_off_time = _this.validate_drop_off_time();
    if (drop_off_time.error) {
      first_page_errors.push(drop_off_time);
    }

    if (first_page_errors.length > 0) {
      _this.order_creation_ui.first_page.is_error = true;
    } else {
      _this.order_creation_ui.first_page.is_error = false;
    }

    console.log("what are the errors on the first page");
    console.dir(first_page_errors);

    return first_page_errors;
  }

  validate_drop_off_instructions() {
    var _this = this;
    let err = {};

    if (!_this.order.dropoff.instructions) {
      err.error = true;
      err.message = "Dropoff instructions are required.";
      err.id = 5;
    } else {
      err.error = false;
    }

    return err;
  }

  validate_drop_off_time() {
    var _this = this;
    let err = {};

    if (_this.times.value.id === 1) {
      err.error = true;
      err.message = "A dropoff time is required.";
      err.id = 4;
    } else {
      err.error = false;
    }

    return err;
  }

  validate_pickup_time() {
    var _this = this;
    let err = {};

    if (_this.times.value.id === 1) {
      err.error = true;
      err.message = "A pickup time is required.";
      err.id = 4;
    } else {
      err.error = false;
    }

    return err;
  }

  validate_pickup_date() {
    var _this = this;
    let err = {};

    if (!_this.order.pickup.date_formatted) {
      err.error = true;
      err.message = "A pickup date is required.";
      err.id = 3;
    } else {
      err.error = false;
    }

    return err;
  }

  validate_drop_off_date() {
    var _this = this;
    let err = {};

    if (!_this.order.dropoff.date_formatted) {
      err.error = true;
      err.message = "A dropoff date is required.";
      err.id = 3;
    } else {
      err.error = false;
    }

    return err;
  }

  validate_order_name() {
    var _this = this;

    let err = {};

    if (!_this.order.name) {
      err.error = true;
      err.message = "An order name is required.";
      err.id = 1;
    } else {
      err.error = false;
    }

    return err;
  }

  validate_order_payment() {
    var _this = this;
    let err = {};

    if (_this.order.payment) {
      let passes_regex = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(_this.order.payment);
      if (!passes_regex) {
        err.error = true;
        err.message = "The payment is formatted incorrectly.";
        err.id = 2;
      } else {
        err.error = false;
      }
    } else {
      err.error = false;
    }

    return err;
  }

  validate_pickup_address() {
    var _this = this;
    let err = {};
    if (!_this.order.pickup.address) {
      err.error = true;
      err.message = "A pickup address is required.";
      err.id = 1;
    } else {
      err.error = false;
    }
    return err;
  }

  validate_dropoff_address() {
    var _this = this;
    let err = {};

    if (!_this.order.dropoff.address) {
      err.error = true;
      err.message = "A dropoff address is required.";
      err.id = 1;
      //_this.order_creation_ui.first_page.is_error_address=true;
    } else {
      err.error = false;
    }
    return err;
  }

  validate_pickup_location() {
    var _this = this;
    let err = {};
    if (!_this.order.pickup.location) {
      err.error = true;
      err.message = "A pickup location is required.";
      err.id = 2;
      //_this.order_creation_ui.first_page.is_error_location=true;
    } else {
      err.error = false;
    }
    return err;
  }

  validate_dropoff_location() {
    var _this = this;
    let err = {};
    if (!_this.order.dropoff.location) {
      err.error = true;
      err.message = "A dropoff location is required.";
      err.id = 2;
      //_this.order_creation_ui.first_page.is_error_location=true;
    } else {
      err.error = false;
    }
    return err;
  }

  back_to_step_one() {
    var _this = this;
    _this.page = 1;
    _this.setLoader();
    _this.remain_loading_count = 1;
    let index = _this.times.values.findIndex((p) => p.id == _this.order.dropoff.time.id);
    let time_selector = _this.times.values[index];
    _this.$timeout(function () {
      _this.times.value.id = time_selector.id;
      _this.order.dropoff.time = time_selector;
    });
    _this.set_address_to_google_places(_this.order.dropoff.address);
    _this.$timeout(function () {
      _this.remain_loading_count = 0;
      _this.unSetLoader();
    }, 1000);
  }

  back_to_step_two() {
    var _this = this;
    _this.page = 2;
    _this.setLoader();
    _this.remain_loading_count = 1;
    let index = _this.times.values.findIndex((p) => p.id == _this.order.pickup.time.id);
    let time_selector = _this.times.values[index];
    _this.$timeout(function () {
      _this.times.value.id = time_selector.id;
      _this.order.pickup.time = time_selector;
    });
    _this.set_address_to_google_places(_this.order.pickup.address);
    _this.$timeout(function () {
      _this.remain_loading_count = 0;
      _this.unSetLoader();
    }, 1000);
  }

  back_to_step_three() {
    var _this = this;
    _this.page = 3;
  }

  load_page() {
    var _this = this;
    _this.$timeout(function () {
      //_this.remain_loading_count = 0;
      _this.page_loading = false;
    }, 1000);
  }

  set_address(params) {
    var _this = this;
    let google_response = params.address.adr_address;
    let coords = params.address;
    let shift_data = {};
    shift_data.contactInfo = {};
    shift_data.contactInfo.lat = coords.lat;
    shift_data.contactInfo.lng = coords.lng;
    let address_array = google_response.split(",");
    try {
      address_array.forEach(function (part, index) {
        if (part.indexOf("street-address") > -1) {
          let street_array = /<span[^>]*>(.*?)<\/span>/.exec(part);
          shift_data.contactInfo.streetLine1 = street_array[1];
        }
        if (part.indexOf("locality") > -1) {
          let city_array = /<span[^>]*>(.*?)<\/span>/.exec(part);
          shift_data.contactInfo.city = city_array[1];
        }
        if (part.indexOf("region") > -1) {
          let regionAndZipArray = part.split("> <");

          regionAndZipArray.forEach(function (p) {
            if (p.indexOf("region") > -1) {
              let state_array = /\s<span[^>]*>(.*?)<\/span/.exec(p);
              shift_data.contactInfo.state = state_array[1];
            }
            if (p.indexOf("postal-code") > -1) {
              let zip_array = /span[^>]*>(.*?)<\/span>/.exec(p);
              shift_data.contactInfo.zipCode = zip_array[1];
            }
          });
        }
      });
    } catch (err) {
      console.log("error looping googleplaces");
      console.dir(err);
    }
    _this.getTimeZones(shift_data);
  }

  getTimeZones(shift_data) {
    var _this = this;
    _this.$security.getEventShiftTimezoneInfo(shift_data).then(
      function (response) {
        console.log("response");
        console.dir(response);
        if (response.status === 200) {
          let places_data = response.data[0];
          _this.compareTimeZones(places_data, shift_data);
        }
      },
      function (error) {
        console.log("error getting zipcodes");
        console.dir(error);
      }
    );
  }

  compareTimeZones(places_data, shift_data) {
    var _this = this;
    let client_time_zone = moment.tz.guess();
    let shift_time_zone = places_data.timeZoneId;
    if (_this.page === 1) {
      _this.order.user_time_zone = client_time_zone;
      _this.order.dropoff.address =
        shift_data.contactInfo.streetLine1 +
        " " +
        shift_data.contactInfo.city +
        " " +
        shift_data.contactInfo.state +
        " " +
        shift_data.contactInfo.zipCode;
      _this.order.dropoff.contactInfo = shift_data.contactInfo;
      _this.order.dropoff.time_zone_id = shift_time_zone;
      _this.order.dropoff.raw_offset = places_data.rawOffset;
      _this.order_creation_ui.first_page.is_error = false;
    } else if (_this.page === 2) {
      _this.order.pickup.address =
        shift_data.contactInfo.streetLine1 +
        " " +
        shift_data.contactInfo.city +
        " " +
        shift_data.contactInfo.state +
        " " +
        shift_data.contactInfo.zipCode;
      _this.order.pickup.contactInfo = shift_data.contactInfo;
      _this.order.pickup.time_zone_id = shift_time_zone;
      _this.order.pickup.raw_offset = places_data.rawOffset;
      _this.order_creation_ui.second_page.is_error = false;
    }
  }

  set_date_picker() {
    var _this = this;
    _this.$timeout(function () {
      $("#datepicker-dropoff").datepicker({
        showOn: "both",
        buttonImage: "/app/vendor/images/calender.png",
        buttonImageOnly: true,
        buttonText: "Select date",
        dateFormat: "M dd, yy",
      });
    }, 100);

    _this.$timeout(function () {
      $("#datepicker-pickup").datepicker({
        showOn: "both",
        buttonImage: "/app/vendor/images/calender.png",
        buttonImageOnly: true,
        buttonText: "Select date",
        dateFormat: "M dd, yy",
      });
    }, 100);
  }

  set_padding() {
    var _this = this;
    //{id:6,name:"1:00 AM"},{id:7,name:"1:15 AM"},{id:8,name:"1:30 AM"},{id:9,name:"1:45 AM"}
    let padding_times = {
      value: {
        id: 1,
        name: "Select Padding",
      },
      values: [
        {
          id: 1,
          name: "Select Padding",
        },
        {
          id: 2,
          name: "15 Min",
        },
        {
          id: 3,
          name: "30 Min",
        },
        {
          id: 4,
          name: "45 Min",
        },
        {
          id: 5,
          name: "1 Hour",
        },
      ],
    };

    _this.padding_times = padding_times;
  }

  changing_times() {
    var _this = this;
    console.log("changing times");
    console.dir(_this.times.value.id);
  }

  changing_padding() {
    var _this = this;
    console.log("chaning padding");
    console.dir(_this.padding_time.id);
  }

  pickup_location_change() {
    var _this = this;
    console.log("pickup_location_change");
  }

  order_name_change() {
    var _this = this;
    if (_this.order_creation_ui.third_page.is_error_order_name) {
      _this.order_creation_ui.third_page.is_error_order_name = false;
    }
  }

  dropoff_location_change() {
    var _this = this;
    if (_this.order_creation_ui.first_page.is_error_location) {
      _this.order_creation_ui.first_page.is_error_location = false;
      _this.order_creation_ui.first_page.is_error = false;
    }
  }

  pickup_location_change() {
    var _this = this;
    if (_this.order_creation_ui.second_page.is_error_location) {
      _this.order_creation_ui.second_page.is_error_location = false;
      _this.order_creation_ui.second_page.is_error = false;
    }
  }

  changing_dropoff_instructions() {
    var _this = this;
    if (_this.order.dropoff.instructions) {
      _this.order_creation_ui.first_page.is_error_instructions = false;
    }
  }

  changing_pickup_instructions() {
    var _this = this;
    if (_this.order.pickup.instructions) {
      _this.order_creation_ui.second_page.is_error_instructions = false;
    }
  }

  updateTracker(page) {
    var _this = this;
    if (_this.tracker.visited_steps.indexOf(page) > -1) {
      _this.page = page;
    } else {
      console.log("nothing");
    }
  }

  calc_numbers() {
    var _this = this;
    let passes_regex = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(_this.order.payment);
    console.log("passes_regex");
    console.dir(passes_regex);
    console.dir(_this.order.payment);
    console.dir(_this.order.payment_adj);
    if (_this.order.payment && passes_regex === false && _this.order.payment !== "") {
      _this.order_creation_ui.third_page.is_error_payment = true;
      _this.order_creation_ui.third_page.is_error_payment_msg = "Correct format Ex. (50.00)";
    } else {
      _this.order_creation_ui.third_page.is_error_payment = false;
      _this.order_creation_ui.third_page.is_error_payment_msg = null;
    }
    //_this.event.hourly_rate_adj = "";
    if (isNaN(_this.order.payment_adj)) {
      _this.order.payment_adj = "";
      // || _this.ismarketing
      if (_this.order.is_clone) {
        _this.order.payment_adj = (parseFloat(_this.order.payment) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
      }
    } else {
      if (!_this.currentUser) {
        _this.order.payment_adj = (parseFloat(_this.order.payment) * 0.75).toFixed(2);
      } else {
        _this.order.payment_adj = (parseFloat(_this.order.payment) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
      }
      if (isNaN(_this.order.payment_adj)) {
        _this.order.payment_adj = "";
      }
    }
  }

  calc_numbers_adj() {
    var _this = this;
    let passes_regex = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(_this.order.payment);
    console.log("passes_regex");
    console.dir(passes_regex);
    console.dir(_this.order.payment);
    console.dir(_this.order.payment_adj);
    if (_this.order.payment_adj && passes_regex === false && _this.order.payment_adj !== "") {
      _this.order_creation_ui.third_page.is_error_payment = true;
      _this.order_creation_ui.third_page.is_error_payment_msg = "Correct format Ex. (50.00)";
    } else {
      _this.order_creation_ui.third_page.is_error_payment = false;
      _this.order_creation_ui.third_page.is_error_payment_msg = null;
    }
    if (isNaN(_this.order.payment)) {
      _this.event.hourly_rate = "";
    } else {
      if (!_this.currentUser) {
        let p = 100 - 0.25 * 100;
        let x = parseFloat(_this.order.payment_adj) * 100;
        let z = x / p;
        _this.order.payment = z.toFixed(2);
      } else {
        let p = 100 - _this.currentUser.company.defaultPlan.jobblerFeePct * 100;
        let x = parseFloat(_this.order.payment_adj) * 100;
        let z = x / p;
        _this.order.payment = z.toFixed(2);
      }
      if (isNaN(_this.order.payment)) {
        _this.order.payment = "";
      }
    }
  }

  /*
    calcNumbers(){
		var _this=this;
		console.log('calcNumberscalcNumberscalcNumberscalcNumberscalcNumberscalcNumbers');
		console.dir(_this.event.hourly_rate);
		console.dir(_this.event.hourly_rate_adj);
		console.dir(_this.currentUser);
		console.dir(isNaN(_this.event.hourly_rate_adj));
		_this.detailsChanged(2, true);
		if (isNaN(_this.event.hourly_rate_adj)){
			_this.event.hourly_rate_adj = "";
			if (_this.isClone || _this.ismarketing) {
				_this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
			}
		} else {
			if (!_this.currentUser) {
				_this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (.75)).toFixed(2);
			} else {
				_this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
			}
			if (isNaN(_this.event.hourly_rate_adj)) {
				_this.event.hourly_rate_adj = "";
			}
		}
	}

	calcNumbersAdj(){
		var _this=this;
		_this.detailsChanged(2, true);
		if (isNaN(_this.event.hourly_rate)){
			_this.event.hourly_rate = "";
		}else{
			if (!_this.currentUser){
				let p = (100 - (.25 * 100));
				let x = parseFloat(_this.event.hourly_rate_adj) * 100;
				let z = x / p;
				_this.event.hourly_rate = z.toFixed(2);
			}else{
				let p = (100 - (_this.currentUser.company.defaultPlan.jobblerFeePct * 100));
				let x = parseFloat(_this.event.hourly_rate_adj) * 100;
				let z = x / p;
				_this.event.hourly_rate = z.toFixed(2);
			}
			if(isNaN(_this.event.hourly_rate)){
				_this.event.hourly_rate = "";
			}
		}
	}
    */

  pickup_date_change(is_clone, skip) {
    var _this = this;

    let d = null;

    if (is_clone) {
      d = _this.order.pickup.date.format();
    } else {
      d = _this.order.pickup.date_formatted;
    }

    if (d) {
      let moment_start_of_date = moment(d).startOf("day");
      let moment_current_day = moment();
      let date_test = null;
      if (_this.times.value.id === 1) {
        date_test = moment_start_of_date.isBefore(moment_current_day);
      } else {
        let id = _this.times.value.id;
        let index = _this.times.values.findIndex((p) => p.id == id);
        let time_selector = _this.times.values[index];
        let time_to_parse = time_selector.name;
        let time_parts_array = time_to_parse.split(/[ :]+/);
        let additional_minutes = 0;
        let ampm = time_parts_array[2];
        let num = time_parts_array[0];

        if (ampm === "PM") {
          console.log("---1");
          if (time_parts_array[0] !== "12") {
            console.log("---3");
            additional_minutes = 720;
          }
        }
        if (num === "12" && ampm === "AM") {
          console.log("---3");
          num = "0";
        }
        let hours_to_minutes = parseInt(num, 10) * 60;
        let minutes_to_minutes = parseInt(time_parts_array[1], 10);
        let minutes_to_add_to_start_of_day = hours_to_minutes + minutes_to_minutes + additional_minutes;
        let date_test_moment = moment_start_of_date.add(minutes_to_add_to_start_of_day, "minutes");
        date_test = date_test_moment.isBefore(moment());
        if (date_test) {
          _this.order_creation_ui.second_page.is_error_date = true;
          _this.order_creation_ui.second_page.is_error = true;
          _this.order_creation_ui.second_page.is_error_time = true;
          _this.order_creation_ui.second_page.is_error_date_msg = "Please select a date the future.";
          _this.order_creation_ui.second_page.is_error_time_msg = "Please select a time in the future.";
        } else {
          _this.order_creation_ui.second_page.is_error_date = false;
          _this.order_creation_ui.second_page.is_error_time = false;
          _this.order_creation_ui.second_page.is_error = false;
          let date_for_order = d;
          _this.format_date_for_order(d);
        }
      }
    }
  }

  dropoff_date_change(is_clone) {
    var _this = this;

    let d = null;
    if (is_clone) {
      d = _this.order.dropoff.date.format();
    } else {
      d = _this.order.dropoff.date_formatted;
    }
    if (d) {
      let moment_start_of_date = moment(d).startOf("day");
      let moment_current_day = moment();
      let date_test = null;
      if (_this.times.value.id === 1) {
        date_test = moment_start_of_date.isBefore(moment_current_day);
      } else {
        let id = _this.times.value.id;
        let index = _this.times.values.findIndex((p) => p.id == id);
        let time_selector = _this.times.values[index];
        let time_to_parse = time_selector.name;
        let time_parts_array = time_to_parse.split(/[ :]+/);
        let additional_minutes = 0;
        let ampm = time_parts_array[2];
        let num = time_parts_array[0];
        if (ampm === "PM") {
          if (time_parts_array[0] !== "12") {
            additional_minutes = 720;
          }
        }
        if (num === "12" && ampm === "AM") {
          num = "0";
        }
        let hours_to_minutes = parseInt(time_parts_array[0], 10) * 60;
        let minutes_to_minutes = parseInt(time_parts_array[1], 10);
        let minutes_to_add_to_start_of_day = hours_to_minutes + minutes_to_minutes + additional_minutes;
        let date_test_moment = moment_start_of_date.add(minutes_to_add_to_start_of_day, "minutes");
        date_test = date_test_moment.isBefore(moment());
        if (date_test) {
          _this.order_creation_ui.first_page.is_error_date = true;
          _this.order_creation_ui.first_page.is_error = true;
          _this.order_creation_ui.first_page.is_error_time = true;
          _this.order_creation_ui.first_page.is_error_date_msg = "Please select a date the future.";
          _this.order_creation_ui.first_page.is_error_time_msg = "Please select a time in the future.";
        } else {
          _this.order_creation_ui.first_page.is_error_date = false;
          _this.order_creation_ui.first_page.is_error_time = false;
          _this.order_creation_ui.first_page.is_error = false;
          let date_for_order = d;
          _this.order.dropoff.date_moment = date_test_moment;
          _this.format_date_for_order(d);
        }
      }
    }
  }

  format_date_for_order(date) {
    var _this = this;

    let some_date = new Date(date);
    let some_date_moment = moment(some_date).startOf("day");
    _this.some_date_moment = some_date_moment;
    _this.check_for_date_time();
  }

  check_for_date_time() {
    var _this = this;

    if (!_this.some_date_moment && _this.page === 2) {
      let some_date = new Date(_this.order.pickup.date_formatted);
      let some_date_moment = moment(some_date).startOf("day");
      _this.some_date_moment = some_date_moment;
    }

    let date_time = null;

    if (!_this.minutes_to_add_to_start_of_day) {
      let id = _this.times.value.id;
      let index = _this.times.values.findIndex((p) => p.id == id);
      let time_selector = _this.times.values[index];
      let time_to_parse = time_selector.name;
      let time_parts_array = time_to_parse.split(/[ :]+/);
      let additional_minutes = 0;
      let ampm = time_parts_array[2];
      let num = time_parts_array[0];
      if (ampm === "PM") {
        if (time_parts_array[0] !== "12") {
          additional_minutes = 720;
        }
      }
      if (num === "12" && ampm === "AM") {
        num = "0";
      }
      let hours_to_minutes = parseInt(num, 10) * 60;
      let minutes_to_minutes = parseInt(time_parts_array[1], 10);
      let minutes_to_add_to_start_of_day = hours_to_minutes + minutes_to_minutes + additional_minutes;
      _this.minutes_to_add_to_start_of_day = minutes_to_add_to_start_of_day;
    }
    if (_this.some_date_moment && _this.minutes_to_add_to_start_of_day) {
      console.log("_this.some_date_moment");
      console.dir(_this.some_date_moment);
      console.dir(_this.minutes_to_add_to_start_of_day);

      date_time = _this.some_date_moment.startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes");

      console.log("date_time before validate");
      console.dir(date_time);

      _this.validate_date_time(date_time);
    } else {
      console.log("we dont have both");
    }
  }

  validate_date_time(date_time) {
    var _this = this;

    if (_this.order_creation_ui.first_page.is_error) {
      return;
    }
    if (_this.page === 1) {
      _this.order_creation_ui.first_page.is_error_date = false;
      _this.order_creation_ui.first_page.is_error_date_msg = null;
      _this.order.dropoff.date_time = date_time.format();
      _this.set_time_interval(_this.order.dropoff.date_time, "dropoff");
      /*
            if(date_time.isBefore(moment())){
            	console.log("we are not here...");
                _this.order_creation_ui.first_page.is_error_date = true;
                _this.order_creation_ui.first_page.is_error_date_msg = "Please select a date and time in the future.";
                _this.order_creation_ui.first_page.is_error_time = true;
            }else{
            	console.log("we come here");
            	_this.order_creation_ui.first_page.is_error_date = false;
                _this.order_creation_ui.first_page.is_error_date_msg = null;
                _this.order.dropoff.date_time = date_time.format();
                _this.set_time_interval(_this.order.dropoff.date_time, "dropoff");
            }
            */
    } else if (_this.page === 2) {
      _this.order_creation_ui.second_page.is_error_date = false;
      _this.order_creation_ui.second_page.is_error_date_msg = null;
      _this.order.pickup.date_time = date_time.format();
      _this.set_time_interval(_this.order.pickup.date_time, "pickup");
      /*
            if (date_time.isBefore(moment())){
                _this.order_creation_ui.second_page.is_error_date = true;
                _this.order_creation_ui.second_page.is_error_date_msg = "Please select a date and time in the future.";
            } else {
                _this.order_creation_ui.second_page.is_error_date = false;
                _this.order_creation_ui.second_page.is_error_date_msg = null;
                _this.order.pickup.date_time = date_time.format();
            }
            */
    }
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  set_time_interval(date_time, type) {
    var _this = this;

    console.log("what is the date_time");
    console.dir(date_time);

    if (type === "dropoff") {
      if (date_time.toString() === "Invalid date") {
        console.log("we have an invalid date...");
      } else {
        _this.order.dropoff.timeInterval = {};
        _this.order.dropoff.timeInterval.startTime = date_time;
        _this.order.dropoff.date_moment = moment(date_time);
        _this.order.dropoff.timeInterval.endTime = moment(date_time).add(15, "minutes").format();
        if (!_this.order.pickup.timeInterval) {
          _this.order.pickup.date_time = moment(date_time).subtract(60, "minutes").format();
          _this.order.pickup.timeInterval = {};
          _this.order.pickup.timeInterval.startTime = moment(date_time).subtract(60, "minutes").format();
          _this.order.pickup.timeInterval.endTime = moment(date_time).subtract(45, "minutes").format();
          _this.order.pickup.date_moment = moment(date_time).subtract(60, "minutes");
          _this.order.pickup.date_time = _this.order.pickup.date_moment.format();
          if (_this.order.pickup.timeInterval.startTime && _this.order.pickup.time_zone) {
            let pickup_time = moment(_this.order.pickup.timeInterval.startTime).tz(_this.order.pickup.time_zone).format("h:mm A");
            let pickup_time_obj = _this.find_time(pickup_time);
            _this.order.pickup.time = pickup_time_obj;
          }
        } else {
          if (_this.order.pickup.date) {
            console.dir(_this.order.pickup.date.format());
          }
          let pd = null;
          if (_this.order.pickup.date_moment) {
            pd = _this.order.pickup.date_moment;
          } else if (_this.order.pickup.date) {
            console.log("2");
            pd = _this.order.pickup.date;
          }
          if (_this.order.dropoff.date_moment.isBefore(pd) || _this.order.dropoff.date_moment.diff(pd) === 0) {
            if (!_this.order.is_clone) {
              _this.order_creation_ui.first_page.is_error_date = true;
              _this.order_creation_ui.first_page.is_error_time = true;
              _this.order_creation_ui.first_page.is_error_date_msg = "Must be after pick-up.";
              _this.order_creation_ui.first_page.is_error_time_msg = "Must be after pick-up.";
              _this.order_creation_ui.first_page.is_error = true;
            }
          } else {
            _this.order_creation_ui.first_page.is_error_date = false;
            _this.order_creation_ui.first_page.is_error_time = false;
            _this.order_creation_ui.first_page.is_error_date_msg = null;
            _this.order_creation_ui.first_page.is_error_time_msg = null;
            _this.order_creation_ui.first_page.is_error = false;
          }
        }
      }
    } else if (type === "pickup") {
      if (date_time.toString() === "Invalid date") {
        console.log("we have an invalid date...");
      }
      if (!_this.order.pickup.timeInterval) {
        _this.order.pickup.timeInterval = {};
        _this.order.pickup.timeInterval.startTime = date_time;
        _this.order.pickup.date_moment = moment(date_time);
        _this.order.pickup.timeInterval.endTime = moment(date_time).add(15, "minutes").format();
      } else {
        _this.order.pickup.timeInterval.startTime = date_time;
        _this.order.pickup.date_moment = moment(date_time);
        _this.order.pickup.timeInterval.endTime = moment(date_time).add(15, "minutes").format();
        _this.order.pickup.date_time = moment(date_time).format();
      }
      if (!_this.order.dropoff.timeInterval) {
        _this.order.dropoff.timeInterval = {};
        _this.order.dropoff.timeInterval.startTime = _this.order.dropoff.date_moment.format();
        _this.order.dropoff.timeInterval.endTime = _this.order.dropoff.date_moment.add(15, "minutes").format();
      }
      let dropoff_starttime = moment(_this.order.dropoff.timeInterval.startTime);
      let pickup_starttime = moment(_this.order.pickup.timeInterval.startTime);
      let difference = dropoff_starttime.diff(pickup_starttime);
      if (dropoff_starttime.isBefore(pickup_starttime) || difference === 0) {
        _this.order_creation_ui.second_page.is_error_date = true;
        _this.order_creation_ui.second_page.is_error_time = true;
        _this.order_creation_ui.second_page.is_error_date_msg = "Must be before drop-off.";
        _this.order_creation_ui.second_page.is_error_time_msg = "Must be before drop-off.";
        _this.order_creation_ui.second_page.is_error = true;
      } else {
        _this.order_creation_ui.second_page.is_error_date = false;
        _this.order_creation_ui.second_page.is_error_time = false;
        _this.order_creation_ui.second_page.is_error_date_msg = null;
        _this.order_creation_ui.second_page.is_error_time_msg = null;
        _this.order_creation_ui.second_page.is_error = false;
      }
    }
  }

  time_change(send) {
    var _this = this;
    let id = _this.times.value.id;
    let index = _this.times.values.findIndex((p) => p.id == id);
    let time_selector = _this.times.values[index];
    if (send === 1) {
      _this.order.dropoff.time = time_selector;
    } else if (send === 2) {
      _this.order.pickup.time = time_selector;
    }
    let time_to_parse = time_selector.name;
    let time_parts_array = time_to_parse.split(/[ :]+/);
    let additional_minutes = 0;
    let ampm = time_parts_array[2];
    let num = time_parts_array[0];
    if (ampm === "PM") {
      if (time_parts_array[0] !== "12") {
        additional_minutes = 720;
      }
    }
    if (num === "12" && ampm === "AM") {
      num = "0";
    }
    let hours_to_minutes = parseInt(num, 10) * 60;
    let minutes_to_minutes = parseInt(time_parts_array[1], 10);
    let minutes_to_add_to_start_of_day = hours_to_minutes + minutes_to_minutes + additional_minutes;
    _this.minutes_to_add_to_start_of_day = minutes_to_add_to_start_of_day;
    if (_this.times.value.id !== 1) {
      if (_this.page === 1) {
        if (_this.order.dropoff.date_formatted) {
          let date_selected_and_time = null;
          let date_selected_and_time_formatted = null;
          let now = moment().format();
          let min_to_add = _this.minutes_to_add_to_start_of_day;

          if (_this.order.is_clone) {
            date_selected_and_time = moment(_this.order.dropoff.date).startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes");
            date_selected_and_time_formatted = moment(_this.order.dropoff.date_formatted)
              .startOf("day")
              .add(_this.minutes_to_add_to_start_of_day, "minutes")
              .format();
          } else {
            date_selected_and_time = moment(_this.order.dropoff.date_formatted).startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes");
            date_selected_and_time_formatted = moment(_this.order.dropoff.date_formatted)
              .startOf("day")
              .add(_this.minutes_to_add_to_start_of_day, "minutes")
              .format();
          }
          let now_conv = moment(now);
          let conv = moment(date_selected_and_time_formatted);
          _this.order.dropoff.date_moment = moment(date_selected_and_time_formatted);
          _this.some_date_moment = moment(date_selected_and_time_formatted);
          _this.check_for_date_time();
          /*
	            	if(now_conv.isBefore(conv, 'minute')){
	            		_this.order_creation_ui.first_page.is_error_time = false;
	            		_this.order_creation_ui.first_page.is_error = false;
	            		_this.order_creation_ui.first_page.is_error_time_msg = "";
	            		_this.check_for_date_time();
	            	}else{
	            		_this.order_creation_ui.first_page.is_error_time = true;
	            		_this.order_creation_ui.first_page.is_error_time_msg = "Please select a time in the future.";
	            		_this.order_creation_ui.first_page.is_error = true
	            	}
	            	*/
        } else {
          console.log("no date");
        }
      } else if (_this.page === 2) {
        if (_this.order.pickup.date_formatted) {
          let min_to_add = _this.minutes_to_add_to_start_of_day;
          let date_selected_and_time = null;
          let date_selected_and_time_formatted = null;
          let now = moment().format();

          if (_this.order.is_clone) {
            date_selected_and_time = moment(_this.order.pickup.date).startOf("day").add(min_to_add, "minutes");
            date_selected_and_time_formatted = moment(_this.order.pickup.date_formatted)
              .startOf("day")
              .add(_this.minutes_to_add_to_start_of_day, "minutes")
              .format();
          } else {
            date_selected_and_time = moment(_this.order.pickup.date_formatted).startOf("day").add(min_to_add, "minutes");
            date_selected_and_time_formatted = moment(_this.order.pickup.date_formatted)
              .startOf("day")
              .add(_this.minutes_to_add_to_start_of_day, "minutes")
              .format();
            //date_selected_and_time_formatted = moment(_this.order.dropoff.date_formatted).startOf('day').add(_this.minutes_to_add_to_start_of_day, 'minutes').format();
          }

          let now_conv = moment(now);
          let conv = moment(date_selected_and_time_formatted);
          _this.order.pickup.date_moment = moment(date_selected_and_time_formatted);
          _this.some_date_moment = moment(date_selected_and_time_formatted);
          if (now_conv.isBefore(conv, "minute")) {
            _this.order_creation_ui.second_page.is_error_time = false;
            _this.order_creation_ui.second_page.is_error = false;
            _this.order_creation_ui.second_page.is_error_time_msg = "";
            _this.check_for_date_time();
          } else {
            _this.order_creation_ui.second_page.is_error_time = true;
            _this.order_creation_ui.second_page.is_error_time_msg = "Please select a time in the future.";
            _this.order_creation_ui.second_page.is_error = true;
          }
        } else {
          console.log("no date");
        }
      }
    }
  }

  post_order() {
    var _this = this;
    let created_pool = _this.create_pool();
  }

  create_pool() {
    var _this = this;
    let order = _this.order;
    _this.setLoader();
    let jts = _this.$rootScope.jobble_types;
    _this.$events.create_jobble_pool(order, jts).then(
      function (response) {
        if (response.status === 200 && response.data.jobblePool) {
          _this.push_jobbles_to_team(response.data.jobblePool, order);
        } else {
          _this.unSetLoader();
          _this.handle_jobble_pool_creation_error(response);
        }
        _this.$timeout(function () {
          $("#modal-post-event").modal("toggle");
        });
      },
      function (error) {
        _this.$timeout(function () {
          $("#modal-post-event").modal("toggle");
          _this.unSetLoader();
        });
        _this.handle_jobble_pool_creation_error(error);
      }
    );
  }

  mark_order_as_published(jobble_pool) {
    var _this = this;
    _this.$timeout(function () {
      _this.$events.mark_order_as_published(jobble_pool);
      _this.notifyUsers(jobble_pool);
    }, 300);
    _this.$timeout(function () {
      _this.unSetLoader();
      _this.$state.go("events");
    }, 1000);
  }

  handle_jobble_pool_creation_error(error) {
    var _this = this;
  }

  push_jobbles_to_team(jobble_pool, order) {
    var _this = this;
    _this.$events.push_to_teams(jobble_pool, order).then(
      function (response) {
        _this.mark_order_as_published(jobble_pool);
      },
      function (error) {}
    );
  }

  check_teams() {
    var _this = this;
    if (_this.currentUser) {
      if (!_this.teams) {
        _this.load_teams();
      }
    }
  }

  load_teams() {
    var _this = this;
    let teams = [];

    _this.$companies.getTeamsSimple().then(
      function (response) {
        try {
          response.data.forEach(function (team, index) {
            var teamsObj = {};
            teamsObj.name = team.name;
            teamsObj.id = team.id;
            teams.push(teamsObj);
          });
        } catch (err) {
          console.log("teams error");
        }
        _this.teams = teams;
      },
      function (data) {
        _this.$timeout(function () {
          $("#show-application-alert").modal("toggle");
        }, 100);
      }
    );
  }

  check_for_clone() {
    var _this = this;
    let event_id = _this.$location.$$search.eid;
    if (event_id) {
      _this.$events.getEventByIdTrimmed(event_id, 1).then(
        function (response) {
          if (response.status === 200) {
            _this.sort_shifts(response.data);
          }
          _this.$timeout(function () {
            _this.remain_loading_count = 0;
          }, 500);
        },
        function (error) {
          _this.$timeout(function () {
            _this.remain_loading_count = 0;
          }, 500);
        }
      );
    } else {
      _this.$timeout(function () {
        _this.remain_loading_count = 0;
      }, 500);
    }
  }

  sort_shifts(event) {
    var _this = this;
    event.subEvents[0].deduppedJobbles[0].shifts.sort(function (a, b) {
      return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
    });
    _this.map_clone_to_order(event);
    _this.cloned_event = event;
  }

  set_address_to_google_places(address, x) {
    var _this = this;
    console.log("set_address_to_google_places");
    console.dir(address);
    if (x) {
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetPickUpAddressClone", address);
      }, 500);
    } else {
      console.log("do we get to the drop off?");
      console.dir(address);
      console.dir(_this.page_loading);
      if (_this.page_loading === false) {
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetDropOffAddressClone", address);
        }, 1500);
      } else {
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetDropOffAddressClone", address);
        }, 500);
      }
    }
  }

  map_clone_to_order(event) {
    var _this = this;
    _this.order.name = event.name;
    _this.order.is_clone = true;
    _this.order.number = event.orderNumber;
    _this.order.dropoff.time_zone = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.place.timeZoneId;
    _this.order.dropoff.raw_offset = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.place.rawOffset;
    let dropoff_city = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.city;
    let dropoff_state = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.state;
    let dropoff_zip_code = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.zipCode;
    let dropoff_street_line_1 = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.streetLine1;
    let drop_off_shift = event.subEvents[0].deduppedJobbles[0].shifts[1];
    _this.order.dropoff.address = dropoff_street_line_1 + " " + dropoff_city + " " + dropoff_state + " " + dropoff_zip_code;
    _this.order.dropoff.location = event.subEvents[0].deduppedJobbles[0].shifts[1].location;
    _this.order.description = event.subEvents[0].deduppedJobbles[0].description;
    _this.set_address_to_google_places(_this.order.dropoff.address);
    _this.order.dropoff.date = moment(drop_off_shift.timeInterval.startTime).startOf("day");
    _this.order.dropoff.date_formatted = moment(drop_off_shift.timeInterval.startTime).startOf("day").format("MMM Do, YYYY");
    _this.order.dropoff.date_moment = moment(drop_off_shift.timeInterval.startTime);
    _this.order.dropoff.date_time = _this.order.dropoff.date_moment.format();
    _this.order.dropoff.contactInfo = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo;
    let drop_off_time = moment(drop_off_shift.timeInterval.startTime).tz(_this.order.dropoff.time_zone).format("h:mm A");
    let drof_off_time_obj = _this.find_time(drop_off_time);
    _this.times.value.id = drof_off_time_obj.id;
    _this.order.dropoff.time = drof_off_time_obj;
    _this.order.payment = (event.subEvents[0].deduppedJobbles[0].payPerHour / 100).toFixed(2);
    _this.calc_numbers();
    //_this.calc_numbers_adj();
    //_this.order.payment_adj = _this.calc_numbers_adj();
    _this.order.hourly_rate = event.subEvents[0].deduppedJobbles[0].payPerHour;
    _this.order.dropoff.instructions = event.subEvents[0].deduppedJobbles[0].shifts[1].description;
    _this.order.dropoff.contact = event.subEvents[0].deduppedJobbles[0].dropoffContactInfo;
    _this.dropoff_date_change(true);
    _this.check_dropoff_date_time_for_clone(1);
    _this.calc_numbers_adj();
    //_this.set_second_page_to_clone(event);
  }

  check_dropoff_date_time_for_clone() {
    var _this = this;
    _this.$timeout(function () {
      let order = _this.order;
      if (order.dropoff.date_time) {
        if (order.dropoff.date_time.toString() === "Invalid date") {
          console.log("well we need to fix the invalid date");
        }
      }
    }, 1500);
  }

  set_second_page_to_clone(event) {
    var _this = this;
    //let event = _this.event;
    let pickup_city = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.city;
    let pickup_state = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.state;
    let pickup_zip_code = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.zipCode;
    let pickup_street_line_1 = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.streetLine1;
    _this.order.pickup.time_zone = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.place.timeZoneId;
    _this.order.pickup.raw_offset = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.place.rawOffset;
    let pickup_shift = event.subEvents[0].deduppedJobbles[0].shifts[0];
    _this.order.pickup.address = pickup_street_line_1 + " " + pickup_city + " " + pickup_state + " " + pickup_zip_code;
    _this.order.pickup.location = event.subEvents[0].deduppedJobbles[0].shifts[0].location;
    _this.order.pickup.contactInfo = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo;
    _this.set_address_to_google_places(_this.order.pickup.address, 1);
    _this.order.pickup.date = moment(pickup_shift.timeInterval.startTime).startOf("day");
    _this.order.pickup.date_formatted = moment(pickup_shift.timeInterval.startTime).startOf("day").format("MMM Do, YYYY");
    _this.order.pickup.date_moment = moment(pickup_shift.timeInterval.startTime);
    _this.order.pickup.date_time = _this.order.dropoff.date_moment.format();
    let pickup_time = moment(pickup_shift.timeInterval.startTime).format("h:mm A");
    let pickup_time2 = moment(_this.order.pickup.date_time).subtract(60, "minutes").format("h:mm A");
    let pickup_time_obj = _this.find_time(pickup_time2);
    _this.order.pickup.time = pickup_time_obj;
    _this.order.pickup.instructions = event.subEvents[0].deduppedJobbles[0].shifts[0].description;
    _this.order.pickup.contact = event.subEvents[0].deduppedJobbles[0].pickupContactInfo;
    _this.$timeout(function () {
      _this.times.value.id = pickup_time_obj.id;
      _this.pickup_date_change(true);
      _this.check_pickup_date_time_for_clone();
    });
  }

  check_pickup_date_time_for_clone() {
    var _this = this;
    /*
        _this.$timeout(function(){
            console.log("order lets get a date time for the clone");
            console.dir(_this.order);
            let order = _this.order;
            if(order.pickup.date_time){
                if(order.pickup.date_time.toString()==="Invalid date"){
                    console.log("well we need to fix the invalid date");
                }
            }
        },2000);
        */
  }

  find_time(time) {
    var _this = this;
    let t = null;
    try {
      for (var i = 0; i < _this.times.values.length; i++) {
        if (time === _this.times.values[i].name) {
          t = _this.times.values[i];
          break;
        }
      }
    } catch (err) {
      console.log("error");
      console.dir(err);
    }
    return t;
  }

  set_third_page_to_clone() {
    var _this = this;
    let event = _this.cloned_event;
  }

  setNextDay() {
    var _this = this;
    if (!_this.order.pickup.date_formatted) {
      _this.order.pickup.date_formatted = _this.order.dropoff.date_formatted;
      _this.order.pickup.date = moment(_this.order.dropoff.date_formatted).startOf("day");
    }
    if (!_this.order.pickup.time) {
      let time_temp = _this.order.dropoff.time.id;
      time_temp = time_temp - 4;
      let index = _this.times.values.findIndex((p) => p.id == time_temp);
      let time_holder = _this.times.values[index];
      _this.order.pickup.time = time_holder;
      _this.$timeout(function () {
        _this.times.value.id = time_holder.id;
      }, 500);
    } else {
      if (_this.order.pickup.time) {
        let id = _this.order.pickup.time.id;
        let i = _this.times.values.findIndex((p) => p.id == id);
        let time_holders = _this.times.values[i];
        _this.$timeout(function () {
          _this.times.value.id = time_holders.id;
        }, 500);
      }
    }
    if (_this.order.pickup.address) {
      _this.set_address_to_google_places(_this.order.pickup.address);
    }
  }

  check_root(jts) {
    var _this = this;
    let jt = _this.$rootScope.jobble_types;
    let types = null;
    if (jt) {
      if (Array.isArray(jt)) {
        types = jt;
      } else {
        types = jt.jobbleTypes;
      }
      _this.find_jt(types);
    } else {
      _this.get_jobble_types();
    }
  }

  get_jobble_types() {
    var _this = this;
    _this.$auth.getJobbleTypes().then(
      function (data) {
        _this.find_jt(data.data);
      },
      function (error) {
        console.log("error getting jobble types");
        console.dir(error);
      }
    );
  }

  find_jt(jobble_types) {
    var _this = this;
    if (jobble_types) {
      let index = jobble_types.findIndex((p) => p.name == "Delivery");
      _this.order.jobble_type_id_for_backend = jobble_types[index].id;
    }
  }

  set_times() {
    var _this = this;
    let times = {
      value: {
        id: 1,
        name: "Select Time",
      },
      values: [
        {
          id: 1,
          name: "Select Time",
        },
        {
          id: 2,
          name: "12:00 AM",
        },
        {
          id: 3,
          name: "12:15 AM",
        },
        {
          id: 4,
          name: "12:30 AM",
        },
        {
          id: 5,
          name: "12:45 AM",
        },
        {
          id: 6,
          name: "1:00 AM",
        },
        {
          id: 7,
          name: "1:15 AM",
        },
        {
          id: 8,
          name: "1:30 AM",
        },
        {
          id: 9,
          name: "1:45 AM",
        },
        {
          id: 10,
          name: "2:00 AM",
        },
        {
          id: 11,
          name: "2:15 AM",
        },
        {
          id: 12,
          name: "2:30 AM",
        },
        {
          id: 13,
          name: "2:45 AM",
        },
        {
          id: 14,
          name: "3:00 AM",
        },
        {
          id: 15,
          name: "3:15 AM",
        },
        {
          id: 16,
          name: "3:30 AM",
        },
        {
          id: 17,
          name: "3:45 AM",
        },
        {
          id: 18,
          name: "4:00 AM",
        },
        {
          id: 19,
          name: "4:15 AM",
        },
        {
          id: 20,
          name: "4:30 AM",
        },
        {
          id: 21,
          name: "4:45 AM",
        },
        {
          id: 22,
          name: "5:00 AM",
        },
        {
          id: 23,
          name: "5:15 AM",
        },
        {
          id: 24,
          name: "5:30 AM",
        },
        {
          id: 25,
          name: "5:45 AM",
        },
        {
          id: 26,
          name: "6:00 AM",
        },
        {
          id: 27,
          name: "6:15 AM",
        },
        {
          id: 28,
          name: "6:30 AM",
        },
        {
          id: 29,
          name: "6:45 AM",
        },
        {
          id: 30,
          name: "7:00 AM",
        },
        {
          id: 31,
          name: "7:15 AM",
        },
        {
          id: 32,
          name: "7:30 AM",
        },
        {
          id: 33,
          name: "7:45 AM",
        },
        {
          id: 34,
          name: "8:00 AM",
        },
        {
          id: 34,
          name: "8:15 AM",
        },
        {
          id: 35,
          name: "8:30 AM",
        },
        {
          id: 36,
          name: "8:45 AM",
        },
        {
          id: 37,
          name: "9:00 AM",
        },
        {
          id: 38,
          name: "9:15 AM",
        },
        {
          id: 39,
          name: "9:30 AM",
        },
        {
          id: 40,
          name: "9:45 AM",
        },
        {
          id: 41,
          name: "10:00 AM",
        },
        {
          id: 42,
          name: "10:15 AM",
        },
        {
          id: 43,
          name: "10:30 AM",
        },
        {
          id: 44,
          name: "10:45 AM",
        },
        {
          id: 45,
          name: "11:00 AM",
        },
        {
          id: 46,
          name: "11:15 AM",
        },
        {
          id: 47,
          name: "11:30 AM",
        },
        {
          id: 48,
          name: "11:45 AM",
        },
        {
          id: 49,
          name: "12:00 PM",
        },
        {
          id: 50,
          name: "12:15 PM",
        },
        {
          id: 51,
          name: "12:30 PM",
        },
        {
          id: 52,
          name: "12:45 PM",
        },
        {
          id: 53,
          name: "1:00 PM",
        },
        {
          id: 54,
          name: "1:15 PM",
        },
        {
          id: 55,
          name: "1:30 PM",
        },
        {
          id: 56,
          name: "1:45 PM",
        },
        {
          id: 57,
          name: "2:00 PM",
        },
        {
          id: 58,
          name: "2:15 PM",
        },
        {
          id: 59,
          name: "2:30 PM",
        },
        {
          id: 60,
          name: "2:45 PM",
        },
        {
          id: 61,
          name: "3:00 PM",
        },
        {
          id: 62,
          name: "3:15 PM",
        },
        {
          id: 63,
          name: "3:30 PM",
        },
        {
          id: 64,
          name: "3:45 PM",
        },
        {
          id: 65,
          name: "4:00 PM",
        },
        {
          id: 66,
          name: "4:15 PM",
        },
        {
          id: 67,
          name: "4:30 PM",
        },
        {
          id: 68,
          name: "4:45 PM",
        },
        {
          id: 69,
          name: "5:00 PM",
        },
        {
          id: 70,
          name: "5:15 PM",
        },
        {
          id: 71,
          name: "5:30 PM",
        },
        {
          id: 72,
          name: "5:45 PM",
        },
        {
          id: 73,
          name: "6:00 PM",
        },
        {
          id: 74,
          name: "6:15 PM",
        },
        {
          id: 75,
          name: "6:30 PM",
        },
        {
          id: 76,
          name: "6:45 PM",
        },
        {
          id: 77,
          name: "7:00 PM",
        },
        {
          id: 78,
          name: "7:15 PM",
        },
        {
          id: 79,
          name: "7:30 PM",
        },
        {
          id: 80,
          name: "7:45 PM",
        },
        {
          id: 81,
          name: "8:00 PM",
        },
        {
          id: 82,
          name: "8:15 PM",
        },
        {
          id: 83,
          name: "8:30 PM",
        },
        {
          id: 84,
          name: "8:45 PM",
        },
        {
          id: 85,
          name: "9:00 PM",
        },
        {
          id: 86,
          name: "9:15 PM",
        },
        {
          id: 87,
          name: "9:30 PM",
        },
        {
          id: 88,
          name: "9:45 PM",
        },
        {
          id: 89,
          name: "10:00 PM",
        },
        {
          id: 90,
          name: "10:15 PM",
        },
        {
          id: 91,
          name: "10:30 PM",
        },
        {
          id: 92,
          name: "10:45 PM",
        },
        {
          id: 93,
          name: "11:00 PM",
        },
        {
          id: 94,
          name: "11:15 PM",
        },
        {
          id: 95,
          name: "11:30 PM",
        },
        {
          id: 96,
          name: "11:45 PM",
        },
      ],
    };

    let pickup_times = {
      value: {
        id: 1,
        name: "Select Time",
      },
      values: [
        {
          id: 1,
          name: "Select Time",
        },
        {
          id: 2,
          name: "12:00 AM",
        },
        {
          id: 3,
          name: "12:15 AM",
        },
        {
          id: 4,
          name: "12:30 AM",
        },
        {
          id: 5,
          name: "12:45 AM",
        },
        {
          id: 6,
          name: "1:00 AM",
        },
        {
          id: 7,
          name: "1:15 AM",
        },
        {
          id: 8,
          name: "1:30 AM",
        },
        {
          id: 9,
          name: "1:45 AM",
        },
        {
          id: 10,
          name: "2:00 AM",
        },
        {
          id: 11,
          name: "2:15 AM",
        },
        {
          id: 12,
          name: "2:30 AM",
        },
        {
          id: 13,
          name: "2:45 AM",
        },
        {
          id: 14,
          name: "3:00 AM",
        },
        {
          id: 15,
          name: "3:15 AM",
        },
        {
          id: 16,
          name: "3:30 AM",
        },
        {
          id: 17,
          name: "3:45 AM",
        },
        {
          id: 18,
          name: "4:00 AM",
        },
        {
          id: 19,
          name: "4:15 AM",
        },
        {
          id: 20,
          name: "4:30 AM",
        },
        {
          id: 21,
          name: "4:45 AM",
        },
        {
          id: 22,
          name: "5:00 AM",
        },
        {
          id: 23,
          name: "5:15 AM",
        },
        {
          id: 24,
          name: "5:30 AM",
        },
        {
          id: 25,
          name: "5:45 AM",
        },
        {
          id: 26,
          name: "6:00 AM",
        },
        {
          id: 27,
          name: "6:15 AM",
        },
        {
          id: 28,
          name: "6:30 AM",
        },
        {
          id: 29,
          name: "6:45 AM",
        },
        {
          id: 30,
          name: "7:00 AM",
        },
        {
          id: 31,
          name: "7:15 AM",
        },
        {
          id: 32,
          name: "7:30 AM",
        },
        {
          id: 33,
          name: "7:45 AM",
        },
        {
          id: 34,
          name: "8:00 AM",
        },
        {
          id: 34,
          name: "8:15 AM",
        },
        {
          id: 35,
          name: "8:30 AM",
        },
        {
          id: 36,
          name: "8:45 AM",
        },
        {
          id: 37,
          name: "9:00 AM",
        },
        {
          id: 38,
          name: "9:15 AM",
        },
        {
          id: 39,
          name: "9:30 AM",
        },
        {
          id: 40,
          name: "9:45 AM",
        },
        {
          id: 41,
          name: "10:00 AM",
        },
        {
          id: 42,
          name: "10:15 AM",
        },
        {
          id: 43,
          name: "10:30 AM",
        },
        {
          id: 44,
          name: "10:45 AM",
        },
        {
          id: 45,
          name: "11:00 AM",
        },
        {
          id: 46,
          name: "11:15 AM",
        },
        {
          id: 47,
          name: "11:30 AM",
        },
        {
          id: 48,
          name: "11:45 AM",
        },
        {
          id: 49,
          name: "12:00 PM",
        },
        {
          id: 50,
          name: "12:15 PM",
        },
        {
          id: 51,
          name: "12:30 PM",
        },
        {
          id: 52,
          name: "12:45 PM",
        },
        {
          id: 53,
          name: "1:00 PM",
        },
        {
          id: 54,
          name: "1:15 PM",
        },
        {
          id: 55,
          name: "1:30 PM",
        },
        {
          id: 56,
          name: "1:45 PM",
        },
        {
          id: 57,
          name: "2:00 PM",
        },
        {
          id: 58,
          name: "2:15 PM",
        },
        {
          id: 59,
          name: "2:30 PM",
        },
        {
          id: 60,
          name: "2:45 PM",
        },
        {
          id: 61,
          name: "3:00 PM",
        },
        {
          id: 62,
          name: "3:15 PM",
        },
        {
          id: 63,
          name: "3:30 PM",
        },
        {
          id: 64,
          name: "3:45 PM",
        },
        {
          id: 65,
          name: "4:00 PM",
        },
        {
          id: 66,
          name: "4:15 PM",
        },
        {
          id: 67,
          name: "4:30 PM",
        },
        {
          id: 68,
          name: "4:45 PM",
        },
        {
          id: 69,
          name: "5:00 PM",
        },
        {
          id: 70,
          name: "5:15 PM",
        },
        {
          id: 71,
          name: "5:30 PM",
        },
        {
          id: 72,
          name: "5:45 PM",
        },
        {
          id: 73,
          name: "6:00 PM",
        },
        {
          id: 74,
          name: "6:15 PM",
        },
        {
          id: 75,
          name: "6:30 PM",
        },
        {
          id: 76,
          name: "6:45 PM",
        },
        {
          id: 77,
          name: "7:00 PM",
        },
        {
          id: 78,
          name: "7:15 PM",
        },
        {
          id: 79,
          name: "7:30 PM",
        },
        {
          id: 80,
          name: "7:45 PM",
        },
        {
          id: 81,
          name: "8:00 PM",
        },
        {
          id: 82,
          name: "8:15 PM",
        },
        {
          id: 83,
          name: "8:30 PM",
        },
        {
          id: 84,
          name: "8:45 PM",
        },
        {
          id: 85,
          name: "9:00 PM",
        },
        {
          id: 86,
          name: "9:15 PM",
        },
        {
          id: 87,
          name: "9:30 PM",
        },
        {
          id: 88,
          name: "9:45 PM",
        },
        {
          id: 89,
          name: "10:00 PM",
        },
        {
          id: 90,
          name: "10:15 PM",
        },
        {
          id: 91,
          name: "10:30 PM",
        },
        {
          id: 92,
          name: "10:45 PM",
        },
        {
          id: 93,
          name: "11:00 PM",
        },
        {
          id: 94,
          name: "11:15 PM",
        },
        {
          id: 95,
          name: "11:30 PM",
        },
        {
          id: 96,
          name: "11:45 PM",
        },
      ],
    };
    _this.times = times;
    _this.pickup_times = pickup_times;
  }

  map_order_data(x) {
    var _this = this;
    let data = {};

    if (x === 1) {
      data.date_time = _this.$stateParams.date_time;
      data.instructions = _this.$stateParams.instructions;
      data.job_posting_type = _this.$stateParams.job_posting_type;
      data.location = _this.$stateParams.location;
      data.street_line_1 = _this.$stateParams.street_line_1;
      data.token = _this.$stateParams.t;
    } else {
      data.date_time = _this.$location.$$search.date_time;
      data.instructions = _this.$location.$$search.instructions;
      data.job_posting_type = _this.$location.$$search.job_posting_type;
      data.location = _this.$location.$$search.location;
      data.street_line_1 = _this.$location.$$search.street_line_1;
      data.token = _this.$location.$$search.t;
    }
    return data;
  }

  check_params() {
    var _this = this;
    console.log("what are the start params");
    console.dir(_this.$stateParams);
    console.dir(_this.$location.$$search);
    let data = {};
    if (_this.$location.$$search.job_posting_type) {
      data = _this.map_order_data();

      if (_this.$location.$$search.t) {
        console.log("lets create some data....");
        let promise = _this.$auth.validate_from_marketing_site(data.token);
        promise.then(
          function (response) {
            _this.handle_marketing_user_response(response.data, data);
            _this.currentUser = response.data;
            _this.$localStorage.logged_user = response.data;
            _this.check_teams();
          },
          function (error) {
            _this.handle_marketing_user_error(error);
          }
        );
      } else {
        data.preserve = true;
        _this.$state.go("signin", data);
      }
    } else {
      console.log("in the else");
      console.dir(_this.$stateParams);
      if (_this.$stateParams.job_posting_type) {
        data = _this.map_order_data(1);
        console.log("we have some job posting types");
        console.dir(_this.$stateParams);
        console.dir(data);

        if (_this.$stateParams.t) {
          let promise = _this.$auth.validate_from_marketing_site(data.token);
          promise.then(
            function (response) {
              let job = _this.$stateParams;
              _this.handle_marketing_user_response(response.data, job);
              _this.currentUser = response.data;
              _this.$localStorage.logged_user = response.data;
              _this.check_teams();
            },
            function (error) {
              _this.handle_marketing_user_error(error);
            }
          );
        }
      } else {
        if (!_this.currentUser) {
          _this.$state.go("signin", data);
        }
      }
    }
  }

  handle_marketing_user_response(user, job_data) {
    var _this = this;
    _this.set_address_to_google_places(job_data.street_line_1);
    _this.order.dropoff.address = job_data.street_line_1;
    _this.order.dropoff.location = job_data.location;
    _this.order.dropoff.date_formatted = job_data.date_time;
    _this.order.dropoff.instructions = job_data.instructions;
  }

  handle_marketing_user_error(error) {
    var _this = this;
    console.log("handle_marketing_user_error");
    console.dir(error);
  }

  notifyUsers(info) {
    var _this = this;
    console.log("notifyUsers");
    console.dir(info);
    let data = {};
    data.id = info.jobbles[0].jobblePoolId;
    if (info.jobbles[0].forCircleOnly === true) {
      data.visibility = "EXCLUSIVE";
    } else {
      data.visibility = "PUBLIC";
    }
    _this.$events.notifyJobblers(data).then(
      function (r) {
        console.log("notify response...");
        console.dir(r);
      },
      function (error) {
        console.log("in notify error");
        console.dir(error);
      }
    );
  }
}

PostorderController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "teams",
  "companies",
  "security",
  "$filter",
  "events",
  "$timeout",
  "$location",
  "$rootScope",
  "$scope",
  "tracking",
];

export default PostorderController;



// WEBPACK FOOTER //
// ./client/app/components/postorder/postorder.controller.js